import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38fa3f38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error" }
const _hoisted_2 = { class: "error" }
const _hoisted_3 = { class: "ion-padding-top" }
const _hoisted_4 = {
  key: 0,
  class: "ion-padding-top loader"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ion-padding ion-no-margin" }, "Noch kein Konto ?", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center"} }, "Or continue with name", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Wähle einen Spielernamen", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "So kannst Du unter Deinem (Nick-)Namen Punkte sammeln und Dich in der Bestenliste eintragen!", -1))
const _hoisted_9 = { class: "error" }
const _hoisted_10 = { class: "ion-padding-top" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Für dieses Gerät speichern")
const _hoisted_12 = {
  key: 0,
  class: "ion-padding-top loader"
}
const _hoisted_13 = { class: "error" }
const _hoisted_14 = { class: "ion-padding-top" }
const _hoisted_15 = {
  key: 0,
  class: "ion-padding-top loader"
}
const _hoisted_16 = {
  key: 1,
  class: "ion-padding-top loader"
}
const _hoisted_17 = { class: "error" }
const _hoisted_18 = { class: "ion-padding-top" }
const _hoisted_19 = {
  key: 0,
  class: "ion-padding-top loader"
}
const _hoisted_20 = {
  key: 1,
  class: "ion-padding-top loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_page_header, {
        canGoBack: true,
        title: _ctx.$t('message.login')
      }, null, 8, ["title"]),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              (_ctx.appConfig?.useFullUser)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, {
                          "size-xs": "12",
                          "size-sm": "12",
                          "size-md": "6",
                          "size-lg": "4",
                          "size-xl": "3"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("form", {
                              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"])),
                              novalidate: "",
                              class: "ion-padding"
                            }, [
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, {
                                    color: "dark",
                                    position: "floating"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('message.username')) + " oder " + _toDisplayString(_ctx.$t('message.email')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_input, {
                                    type: "text",
                                    name: "username",
                                    modelValue: _ctx.validateLoginForm.username.$model,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.validateLoginForm.username.$model) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.validateLoginForm?.username?.$errors[0]?.$message), 1),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, {
                                    color: "dark",
                                    position: "floating"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('message.password')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_input, {
                                    type: "password",
                                    name: "password",
                                    modelValue: _ctx.validateLoginForm.password.$model,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.validateLoginForm.password.$model) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.validateLoginForm?.password?.$errors[0]?.$message), 1),
                              _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_ion_button, {
                                  class: "ion-margin-top",
                                  color: "thing-tag",
                                  expand: "block",
                                  type: "submit"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('message.login')), 1)
                                  ]),
                                  _: 1
                                }),
                                (_ctx.isLoading)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                      _createVNode(_component_ion_spinner, { color: "thing-tag" })
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ], 32),
                            _createVNode(_component_ion_button, {
                              color: "dark",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setPasswordResetModalPresented(true))),
                              fill: "clear"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('message.forgetPassword')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_button, {
                              color: "dark",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setResendConfirmationModalPresented(true))),
                              fill: "clear"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('message.resendConfirmationLink')), 1)
                              ]),
                              _: 1
                            }),
                            _hoisted_5,
                            _createVNode(_component_ion_button, {
                              color: "dark",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.router.push('/register'))),
                              fill: "clear"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('message.register')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, {
                          "size-xs": "12",
                          "size-sm": "12",
                          "size-md": "6",
                          "size-lg": "4",
                          "size-xl": "3"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    "size-xs": "12",
                    "size-sm": "12",
                    "size-md": "6",
                    "size-lg": "4",
                    "size-xl": "3"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _hoisted_8,
                      _createElementVNode("form", {
                        onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitLight && _ctx.onSubmitLight(...args)), ["prevent"])),
                        novalidate: "",
                        class: "ion-padding"
                      }, [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, {
                              color: "dark",
                              position: "floating"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('message.name')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              type: "text",
                              name: "name",
                              modelValue: _ctx.validateLightRegisterFrom.name.$model,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.validateLightRegisterFrom.name.$model) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.validateLightRegisterFrom?.name?.$errors[0]?.$message), 1),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_ion_button, {
                            class: "ion-margin-top",
                            color: "thing-tag",
                            expand: "block",
                            type: "submit"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }),
                          (_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createVNode(_component_ion_spinner, { color: "thing-tag" })
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ], 32)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.appConfig?.useFullUser)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_ion_modal, {
              "is-open": _ctx.isPasswordResetModalPresented,
              "swipe-to-close": true,
              "presenting-element": _ctx.$parent?.$refs.ionRouterOutlet,
              onDidDismiss: _ctx.passwordModelDidDismiss
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_header, {
                  translucent: true,
                  class: "ion-no-border"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_toolbar, { color: "thing-tag" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('message.resetPassword')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_buttons, { slot: "end" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, {
                              shape: "round",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setPasswordResetModalPresented(false)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  "aria-label": _ctx.$t('message.close'),
                                  icon: _ctx.close
                                }, null, 8, ["aria-label", "icon"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_grid, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, { size: "12" }, {
                              default: _withCtx(() => [
                                _createElementVNode("form", {
                                  onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args)), ["prevent"])),
                                  novalidate: "",
                                  class: "ion-padding"
                                }, [
                                  _createVNode(_component_ion_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, {
                                        color: "dark",
                                        position: "floating"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('message.email')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_input, {
                                        disabled: _ctx.isEmailSent,
                                        type: "email",
                                        name: "email",
                                        modelValue: _ctx.validateResetPassword.email.$model,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.validateResetPassword.email.$model) = $event))
                                      }, null, 8, ["disabled", "modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.validateResetPassword?.email?.$errors[0]?.$message), 1),
                                  _createElementVNode("div", _hoisted_14, [
                                    _createVNode(_component_ion_button, {
                                      disabled: _ctx.isEmailSent,
                                      class: "ion-margin-top",
                                      color: "thing-tag",
                                      expand: "block",
                                      type: "submit"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('message.send')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"]),
                                    (_ctx.isSending)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                          _createVNode(_component_ion_spinner, { color: "thing-tag" })
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.isEmailSent)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                          _createVNode(_component_ion_text, { color: "thing-tag" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t('message.emailSent')), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 32)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["is-open", "presenting-element", "onDidDismiss"]),
            _createVNode(_component_ion_modal, {
              "is-open": _ctx.isResendConfirmationModalPresented,
              "swipe-to-close": true,
              "presenting-element": _ctx.$parent?.$refs.ionRouterOutlet,
              onDidDismiss: _ctx.resendConfirmationModelDidDismiss
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_header, {
                  translucent: true,
                  class: "ion-no-border"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_toolbar, { color: "thing-tag" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('message.resendConfirmationLink')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_buttons, { slot: "end" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, {
                              shape: "round",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setResendConfirmationModalPresented(false)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  "aria-label": _ctx.$t('message.close'),
                                  icon: _ctx.close
                                }, null, 8, ["aria-label", "icon"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_grid, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, { size: "12" }, {
                              default: _withCtx(() => [
                                _createElementVNode("form", {
                                  onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resendConfirmationLink && _ctx.resendConfirmationLink(...args)), ["prevent"])),
                                  novalidate: "",
                                  class: "ion-padding"
                                }, [
                                  _createVNode(_component_ion_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, {
                                        color: "dark",
                                        position: "floating"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('message.email')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_input, {
                                        disabled: _ctx.isConfimationLinkSent,
                                        type: "email",
                                        name: "email",
                                        modelValue: _ctx.validateResendConfirmationForm.email.$model,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.validateResendConfirmationForm.email.$model) = $event))
                                      }, null, 8, ["disabled", "modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.validateResendConfirmationForm?.email?.$errors[0]?.$message), 1),
                                  _createElementVNode("div", _hoisted_18, [
                                    _createVNode(_component_ion_button, {
                                      disabled: _ctx.isConfimationLinkSent,
                                      class: "ion-margin-top",
                                      color: "thing-tag",
                                      expand: "block",
                                      type: "submit"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('message.send')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"]),
                                    (_ctx.isSendingConfirmationLink)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                          _createVNode(_component_ion_spinner, { color: "thing-tag" })
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.isConfimationLinkSent)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                          _createVNode(_component_ion_text, { color: "thing-tag" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t('message.confirmationLinkSent')), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 32)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["is-open", "presenting-element", "onDidDismiss"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}